    <template >
  <div v-role="roles">

  <div>
  <div class="formPosition">
<!--Dialogo  -->
    <v-dialog v-model="dial_" persistent width="800"><v-card>

            <v-card-title style="background-color:#006699; color:white">Criar modelo de certificado</v-card-title>
                            <v-card-text><v-container>
                              <span ><strong>Um Modelo de certificado</strong> é uma configuração que define o número de disciplinas lecionadas em um determinado anolectivo e que devem constar no certificado.<br>
                                    Selecione o curso e o anolectivo dos quais quer configurar um modelo de certificado, seguidamente clica em <strong>Finalizar.</strong> <br>
                                    Na lista de disciplinas que obter , remova todas aquelas que não foram lecionadas no anolectivo por si selecionado e que não deverão constar nos certificados a serem emitidos para aquele ano.
                              </span><br>Está operação é feita uma única vez por curso e  anolectivo,não havendo necessidade de repetir a mesma operação nos anos seguintes, a menos que uma nova disciplina tenha sido inserida no sistema.<br>
                              <v-alert
                      v-model="is_modelo_certificado"
                      dismissible
                      type="error"
                      border="left"
                      transition="scale-transition"
                      elevation="2"
                      colored-border
                    >
                    Modelo de certificado já existente
                  </v-alert>
                              <v-form ref="form" v-model="formValid" lazy-validation >
                                <v-row style="border:1px solid #ccc;">
                                   <v-col cols="12" sm="6" md="6">
                               <v-select
                                v-model="editedItem.curso"
                                :items="cursos"
                                item-text="descricao"
                                label="Curso"
                                outlined
                                @change="is_modelo_certificado = false"
                                return-object
                                :rules="[v => !!v || 'Campo obrigatorio!', v => (v.idCurso || 0) || 'Campo obrigatorio!' ]" >
                                </v-select>
                          </v-col>
                           <v-col cols="12" sm="6" md="6">
                               <v-select
                                v-model="editedItem.anolectivo"
                                @change="is_modelo_certificado = false"
                                :items="anolectivos"
                                item-text="novadescricao"
                                label="Ano Lectivo"
                                outlined
                                return-object
                                :rules="[v => !!v || 'Campo obrigatorio!', v => (v.idAnoLectivo || 0) || 'Campo obrigatorio!']" >
                                </v-select>
                          </v-col>
                                   </v-row></v-form>
                              </v-container></v-card-text>
                            <v-card-actions><v-spacer></v-spacer>
                            <v-btn color="green darken-1"  @click="initializeDisciplinas()" style="color:white;" :disabled="is_modelo_certificado">Avançar</v-btn>
                           <v-btn color="red darken-1"   style="color:white;" @click="$router.push('welcome')">Cancelar</v-btn>
                          </v-card-actions></v-card>
            </v-dialog>
  <!-- Fim Dialogo  -->
  <!-- =============================================================================== -->

            <v-row justify="center">
            <v-dialog v-model="dialog2" persistent max-width="490">
              <v-card>
                <v-overlay :value="overlay">
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Essa operação irá afectar o sistema como um todo, desejas continuar com essa operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog2=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="save()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->

        <!-- =============================================================================== -->

            <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Desejas eliminar essa disciplina?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="eliminar()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

        <!-- =============================================== -->
  <v-card style="margin:auto;" width="1200" >
        <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
     <v-form
    ref="form2"
    v-model="formValid2"
    lazy-validation
  >
          <v-card-title style="background-color:#006699; color:white" dark>Criar modelo certificado</v-card-title>
          <v-alert
                      v-model="alert"
                      dismissible
                      :type="colorAlert"
                      border="left"
                      transition="scale-transition"
                      elevation="2"
                      colored-border
                    >
                   <span :style="colorTextStyle"> {{msgAlert}} </span>
                  </v-alert>

               <v-row no-gutters>
          <v-col>
            <v-card class="d-flex flex-row mb-6" tile>
              <v-list flat>
               <v-header>
                 <v-row>
              <v-col cols="12" sm="7" md="9"><strong>Curso:</strong> {{(editedItem.curso.descricao)}}  <strong>Ano Lectivo:</strong> {{(editedItem.anolectivo.novadescricao)}} <strong>Disciplinas:</strong> {{disciplinas.length}}</v-col>
              <v-col cols="12" sm="5" md="3">
                    <v-btn :disabled="!disciplinas.length" small color="green" @click="dialog2=true">Finalizar</v-btn>
                  </v-col>
                 </v-row>
               </v-header>
                <hr width="1020px" />

                <v-list-item-group v-model="item" color="primary">

                  <v-row  style="margin-left:50px">
                    <v-col cols="12" sm="12" md="1">N.</v-col>
                    <v-col cols="12" sm="12" md="5">Disciplinas</v-col>
                  </v-row>

                  <v-list-item v-for="(item, i) in disciplinas" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>

                 <v-row  >
                      <v-col cols="12" sm="12" md="1">{{i+1}}.</v-col>

                      <v-col cols="12" sm="12" md="5">
                        <v-list-item-title v-text="item.descricao"></v-list-item-title>

                      </v-col>

                      <v-col cols="12" sm="12" md="1">

                      </v-col>

                      <v-col cols="12" sm="12" md="1">

                      </v-col>

                      <v-col cols="12" sm="12" md="2">
                        <v-btn color="primary" fab  x-small dark>
                          <v-icon  @click="deleteItem(item)">delete</v-icon>
                        </v-btn>
                      </v-col>

                    </v-row>

                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
     </v-form>
      </v-card>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    overlay: false,
    msgAlert: '',
    colorAlert: 'success',
    alert: false,
    dial_: true,
    index: -1,
    dialog: false,
    dialog2: false,
    isLoading: false,
    formValid: true,
    formValid2: true,
    colorTextStyle:'color:black;',
    on: false,
    roles: 'adm',
    text: '',
    itemDelete: null,
    editedpk: 0,
    role_usuario: '',
    disciplinas: [],
    _classe: '',
    offset: true,
    iddisciplina: 0,
    closeOnClick: true,
    item: 1,
    cursos: [],
    anolectivos: [],
    control_modelo_certificados: [],
    editedIndex: -1,
    is_modelo_certificado: false,
    editedItem: {
      curso: { descricao: '', idCurso: 0 },
      anolectivo: { novadescricao: '', idAnoLectivo: 0 },
      idcontrol_disciplina_certificado: 0
    },
    defaultItem: {
      curso: { descricao: '', idCurso: 0 },
      anolectivo: { novadescricao: '', idAnoLectivo: 0 },
      idcontrol_disciplina_certificado: 0
    }
  }),
  computed: {
  },

  watch: {
  },
  created () {
    this.initializeCurso()
    this.initializeAnoLectivo()
  },

  methods: {
    deleteItem (item) {
      this.index = this.disciplinas.indexOf(item)
      this.dialog = true
    },
    eliminar () {
      this.disciplinas.splice(this.index, 1)
      this.dialog = false
    },

    async save () {

      //Verifica o número de disciplinas a preparar e o número de disciplinas total do curso
      if( this.editedItem.curso.numero_disciplinas !== this.disciplinas.length ){
          this.alert = true
          this.dialog2 = false
          this.colorAlert = 'error'
          this.msgAlert = 'Não pode finalizar a configuração do modelo porque esperavam-se '+this.editedItem.curso.numero_disciplinas+' disciplinas e encontraram-se '+this.disciplinas.length+',remova as disciplinas que não pertencem ao anolectivo '+this.editedItem.anolectivo.descricao+'.'
          this.colorTextStyle = 'color:red'
          setTimeout(() => {
            this.alert = false
          }, 8000);
      }else{

            this.dial_ = false
            try {
              this.overlay = true
              let msg2 = await axios
                .post('/modelodisciplinaInsert', { dados: this.disciplinas, curso: this.editedItem.curso, anolectivo: this.editedItem.anolectivo, status_: true, autor_: ls.get('nomeUsuario') })
                .then(res => res.data)
              if (msg2.affectedRows > 0) {
                this.disciplinas = []
                this.editedItem = this.defaultItem
                this.alert = true
                this.colorAlert = 'success'
                 this.colorTextStyle = 'color:black'
                this.msgAlert = 'Modelo criado com sucesso!'
                setTimeout(() => {
                  this.alert = false
                  this.dial_ = true
                }, 2000)
              }

              this.overlay = false
              this.dialog2 = false
            } catch (error) {
              this.overlay = false
              this.dialog2 = false
              this.alert = true
              this.colorAlert = 'error'
               this.colorTextStyle = 'color:red'
              this.msgAlert = error
              setTimeout(() => {
                this.alert = false
              }, 2000)
            }


      }
    },

    async initializeDisciplinas () {
      if (this.$refs.form.validate()) {
        try {
          let msg = await axios
            .post('/load_modelo', { idCurso: this.editedItem.curso.idCurso, idAnoLectivo: this.editedItem.anolectivo.idAnoLectivo })
            .then(res => res.data)
          if (msg.length === 0) {
            this.disciplinas = await axios
              .post('/modelo_disciplina_curso', { idCurso: this.editedItem.curso.idCurso })
              .then(res => res.data)
            this.dial_ = false
          } else {
            /** Exibe o alerta que modelo existente */
            this.is_modelo_certificado = true
          }
        } catch (error) {
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },
    async initializeCurso () {
      try {
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeAnoLectivo () {
      try {
        this.anolectivos = await axios
          .get('/anolectivoAll')
          .then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }
  }
}
</script>
